import axios from 'axios';

export const apiUrl = process.env.NEXT_PUBLIC_API_URL;

const cloudflareHeaders = {
  'CF-Access-Client-Id': process.env.NEXT_PUBLIC_CLOUDFLARE_CLIENT_ID,
  'CF-Access-Client-Secret': process.env.NEXT_PUBLIC_CLOUDFLARE_CLIENT_SECRET,
};

export const api = axios.create({
  baseURL: apiUrl,
  headers:
    !!cloudflareHeaders['CF-Access-Client-Id'] &&
    !!cloudflareHeaders['CF-Access-Client-Secret']
      ? cloudflareHeaders
      : {},
});
